import { createContext, useContext } from 'react';

interface InputRadioContextProps {
	variant: string;
	invalid: boolean;
	readOnly: boolean;
	disabled: boolean;
}

export const InputRadioContext = createContext<InputRadioContextProps>(undefined as unknown as InputRadioContextProps);

export function useInputRadioContext(): InputRadioContextProps {
	const context = useContext(InputRadioContext);
	if (context === undefined) {
		throw new Error('useInputRadioContext must be used within a InputRadio.Root');
	}

	return context;
}
